import type { ListingStatus } from './listing-status'
import type {
  GameRequestStatus,
  GameStatus,
  MemberPointRecordKind,
  OrderItemKind,
  OrderStatus,
  PaymentMethod,
  RefundStatus,
} from './index'

/** 桌游排行榜计入的战绩分流水类型 */
export const rankingPointRecordKinds = [
  'motivation',
  'incentive',
  'adjustment',
  'hunter',
  'reversal',
] as const satisfies readonly MemberPointRecordKind[]

/** 入场与续场，营收里的「入场类收入」 */
export const entryItemKinds = [
  'entry',
  'rebuy',
] as const satisfies readonly OrderItemKind[]

/** 已经发生过赛事消费，不再算新客 */
export const countedCustomerOrderStatuses = [
  'paid',
  'refund_requested',
  'refunding',
  'refunded',
] as const satisfies readonly OrderStatus[]

/** 购买限制占用名额的已支付状态；未支付单另计 */
export const purchaseLimitPaidStatuses = [
  'paid',
  'refund_requested',
  'refunding',
] as const satisfies readonly OrderStatus[]

/** 已出网、需要对账的微信退款 */
export const openRefundStatuses = [
  'pending',
  'processing',
  'abnormal',
] as const satisfies readonly RefundStatus[]

/** 酒品与食品，营收里的「餐饮类收入」 */
export const diningItemKinds = [
  'beverage',
  'food',
] as const satisfies readonly OrderItemKind[]

/** 酒水商品分类写入 order_items.kind */
export const goodsItemKinds = [
  'beverage',
  'food',
  'service',
] as const satisfies readonly OrderItemKind[]

export type GoodsItemKind = (typeof goodsItemKinds)[number]

/** 玩家可主动发起的真实资金支付方式 */
export const playerPaymentMethods = [
  'wechat',
  'lakala',
] as const satisfies readonly PaymentMethod[]

/** 裁判可现场确认的真实资金支付方式 */
export const dealerPaymentMethods = [
  'cash',
] as const satisfies readonly PaymentMethod[]

/** 已占用名额的入场，计数与续场上限判定都用它 */
export const countedGameRequestStatuses = [
  'pending',
  'confirmed',
] as const satisfies readonly GameRequestStatus[]

/** 尚未交分、会阻止重复下单的请求 */
export const openGameRequestStatuses = [
  'pending',
] as const satisfies readonly GameRequestStatus[]

/** 尚未结束、可以入场和操作的赛事 */
export const openGameStatuses = [
  'preparing',
  'running',
] as const satisfies readonly GameStatus[]

export function isOpenGameStatus(
  status: GameStatus,
): status is (typeof openGameStatuses)[number] {
  return status === 'preparing' || status === 'running'
}

/** 后台列表仍展示的档案主体 */
export const listingPresentStatuses = [
  'active',
  'disabled',
] as const satisfies readonly ListingStatus[]
